<template>
    <div class="modal-approval-employee-orders">
        <div class="modals-modal-header">
            {{t('header', {name: name})}}
        </div>

        <div class="modals-modal-body pt-4">

            <div v-if="loading" class="row">
                <div class="col-12">
                    <loading/>
                </div>
            </div>

            <div class="flex-column gap-3 overflow-x-auto" :class="{'d-none':loading, 'd-flex':!loading}">
                <div v-if="0 === orders.length" class="text-center">
                    {{t('empty')}}
                </div>
                <table v-else-if="0 < orders.length" class="table small">
                    <thead>
                    <tr>
                        <th colspan="2">{{t('orders.name')}}</th>
                        <th>{{t('orders.date')}}</th>
                        <th>{{t('orders.status')}}</th>
                        <th class="text-nowrap">{{t('orders.approvedBy')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, index) in orders" :key="index + '_' + order.date">
                        <td>
                            <img v-if="order.pictures[0]?.small"
                                 :src="order.pictures[0]?.small"
                                 :alt="order.name"
                                 class="order-item-image"
                            />
                        </td>
                        <td>{{order.name}}</td>
                        <td>{{d(order.date, 'date')}}</td>
                        <td>{{order.status}}</td>
                        <td>{{order.approvedBy}}</td>
                    </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-center">
                    <pagination v-if="pagination.total"
                                class="bg-white"
                                :default-limit="pagination.limit"
                                :count="pagination.total"
                                :disabled="loading"
                                @refresh="navigate"/>
                </div>
            </div>
        </div>

        <div class="modals-modal-footer">
            <button type="button" class="btn btn-primary" @click="$emit('close')">{{t('cta.close')}}</button>
        </div>
    </div>
</template>

<script>

    import Spinner from "@/components/Spinner.vue";
    import Pagination from "@/components/Pagination.vue";

    export default {
        name: "ModalApprovalEmployeeOrders",
        components: {
            Pagination,
            Spinner
        },
        props: {
            employeeId: {
                type: Number,
                required: true
            },
            name: {
                type: String,
                required: true,
            },
            email: {
                type: String,
                required: true,
            }
        },
        data() {

            return {
                t_path: "modal.approvalEmployeeOrders",
                loading: false,
                error: false,
                pagination: {
                    total: null,
                    offset: 0,
                    limit: 20
                },
                items: []
            }
        },
        computed: {
            orders() {

                return this.items.map((item) => ({
                    ...item,
                    status: this.$t(`orders.status.${item.status}`)
                }))
            },
        },
        methods: {
            load() {

                this.loading = true;

                this.$order
                    .get(`/users/${this.$store.getters["user/id"]}/employees/${this.employeeId}/orders`, {
                        params: {
                            skip: this.pagination.offset,
                            limit: this.pagination.limit
                        }
                    })
                    .then((response) => {

                        this.pagination.total = response.data.pagination.totalCount;

                        this.items = response.data.results.items.map((order) => ({
                            name: order.name,
                            date: order.date,
                            status: order.status,
                            approvedBy: order.approved_by
                                ? ('system' === order.approved_by ? this.t('system') : order.approved_by)
                                : null,
                            pictures: order.pictures,
                        }))
                    })
                    .finally(() => this.loading = false);
            },
            fetch() {

                this.load();
            },
            navigate(pagination) {

                this.pagination.offset = pagination.offset;
                this.pagination.limit = pagination.limit;

                this.load();
            }
        },
        mounted() {

            this.fetch();
        }
    }
</script>

<style scoped lang="scss">

</style>